import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {East} from "@mui/icons-material";
import {Tooltip} from "@mui/material";
import Popover from "@mui/material/Popover";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import {apiPut} from "../../utils/apiRequests";
import ApiEndpoints from "../../utils/ApiEndpoints";
import {getDmpLists, getSelectedDMPLeague} from "../../redux/actions/dmp-actions";

export function ManualDeclareWinner(props) {
    const dispatch = useDispatch();
    const {round, item, group} = props;
    const {league_id, _id} = round;

    const [isOpenPopover, setIsOpenPopover] = useState(false);
    const [popoverAnchorEl, setPopoverAnchorEl] = useState(null);
    const currentDate = new Date();

    const getFormattedDate = () => {
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Month is zero-based
        const day = String(currentDate.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`
    }

    const getFormattedTime = () => {
        const hours = String(currentDate.getHours()).padStart(2, '0');
        const minutes = String(currentDate.getMinutes()).padStart(2, '0');

        return `${hours}:${minutes}`
    }

    const onPopoverShow = (e) => {
        setIsOpenPopover(true);
        setPopoverAnchorEl(e.currentTarget);
    }

    const onPopoverHide = () => {
        setIsOpenPopover(false);
        setPopoverAnchorEl(null);
    }

    const isFinalRound = () => {
        return round.matches.length === 1;
    }

    const isWinner = () => {
        if (group === 'group1') {
            if (item?.is_bye === 'group2') return true;
        } else if (group === 'group2') {
            if (item?.is_bye === 'group1') return true;
        }
    }

    const isLoser = () => {
        if (group === item?.is_bye) {
            return true;
        }
    }

    const validGroups = () => {
        return item.group1?.length > 0 && item.group2?.length > 0;
    }

    const onWinnerDeclare = (e) => {
        const isBye = group === 'group1' ? 'group2' : 'group1';
        let winner = '';

        let groupsPayload = {};

        if (group === 'group1') {
            if (isFinalRound()) {
                winner = 'group1';
            }
            groupsPayload = {
                group1: item.group1.map((group) => ({
                    user_id: group.user_id,
                    name: group.name,
                    mp_score: []
                })),
                group2: item.group2.map((group) => ({
                    user_id: group.user_id,
                    name: 'BYE',
                    mp_score: []
                }))
            }
        } else if (group === 'group2') {
            if (isFinalRound()) {
                winner = 'group2';
            }
            groupsPayload = {
                group1: item.group1.map((group) => ({
                    user_id: group.user_id,
                    name: 'BYE',
                    mp_score: []
                })),
                group2: item.group2.map((group) => ({
                    user_id: group.user_id,
                    name: group.name,
                    mp_score: []
                }))
            }
        }

        const payload = {
            match_id: item._id,
            round_id: _id,
            league_id: league_id,
            groupsdata: {
                date: getFormattedDate(),
                time: getFormattedTime(),
                is_bye: isBye,
                match_status_track: [],
                ...groupsPayload
            }
        }

        if (isFinalRound()) {
            payload.groupsdata = {
                won: winner,
                ...payload.groupsdata
            }
        }

        // console.log(payload); return;

        const url = `${ApiEndpoints.league.base}${ApiEndpoints.league.dmpScoreManualBye}`;
        onPopoverHide();

        apiPut(url,
            payload,
            (response) => {
                dispatch(getSelectedDMPLeague(league_id))
                dispatch(getDmpLists());
            },
            (error) => {
                console.log(error);
            });
    }

    const ConfirmPopover = () => {
        return (
            <Popover
                open={isOpenPopover}
                anchorEl={popoverAnchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                id={'confirm-popover'}
                onClose={onPopoverHide}
            >
                <Box sx={{border: 0, p: 1, bgcolor: "background.paper"}}>
                    <Stack spacing={2} direction="row">
                        <Button
                            variant="contained"
                            color="success"
                            onClick={onWinnerDeclare}
                        >
                            Yes
                        </Button>
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={onPopoverHide}
                        >
                            No
                        </Button>
                    </Stack>
                </Box>
            </Popover>
        );
    }

    return (
        <>
            {(!isWinner() && !isLoser() && validGroups()) &&
                <>
                    <Tooltip title={'Declare Winner'}
                             placement={'right'}>
                        <East onClick={onPopoverShow}/>
                    </Tooltip>
                    <ConfirmPopover/>
                </>
            }
        </>
    );
}